import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const CompareSystemLinks = ({ systems, getColorClass, t }) => (
  <div className="flex flex-col">
    {/* Mobile Section */}

    {/* <div className="flex lg:hidden flex-1 flex-col justify-start">
      <div className="flex flex-col h-12 justify-end" />
      <div className="flex flex-1 flex-row">
        <div className="flex flex-col gap-5">
          <div className="flex h-8 flex-row justify-center items-center px-5 gap-1 border-l border-primary-200}" />
          {systems?.map((system, i) => (
            <div
              key={i}
              className={`flex flex-1 border-l border-primary-200 flex-col p-5 justify-between ${getColorClass(
                i
              )}`}
            >
              <div className="flex flex-1 items-center justify-center">
                {system?.readAboutMoreHref && (
                  <LinkButton
                    key={system?.readAboutMoreHref}
                    href={system?.readAboutMoreHref}
                    size="lg"
                    textTransform="uppercase"
                    className="m-1 font-bold px-10"
                    label={t('common.readMore')}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div> */}
    {/* Desktop Section */}
    <div className="flex flex-row justify-between gap-1 sm:gap-5 pt-5">
      <div className="hidden lg:flex flex-1 flex-col">
        <div className="flex flex-1 flex-col gap-1" />
      </div>
      {systems?.map((system, index) => (
        <div
          key={index}
          className={`flex flex-1 flex-col mb-2 p-5 pt-8 justify-center gap-1 rounded-lg shadow-md ${getColorClass(
            index
          )}`}
        >
          <Stack className="gap-3">
            <Typography
              fontVariant="h5"
              textAlign="center"
              className="text-sm sm:text-clamp-h5 leading-none"
            >
              {system.name}
            </Typography>
            <Typography
              fontVariant="sm"
              textTransform="uppercase"
              textAlign="center"
              className="leading-none"
            >
              {system.company}
            </Typography>
          </Stack>
          {system?.readAboutMoreHref && (
            <LinkButton
              key={system?.readAboutMoreHref}
              href={system?.readAboutMoreHref}
              size="lg"
              className="text-clamp-button text-center mt-6 p-1 max-md:py-2 sm:px-6 sm:py-3 justify-center"
              label={t('compare.readMoreAbout', { systemName: system.name })}
            />
          )}
        </div>
      ))}
    </div>
  </div>
);

export default CompareSystemLinks;
